export default {"src":"/_next/static/media/info-outline.b634926b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};